import classNames from "classnames";
import { useState, useContext } from "react";

import { Icon } from "src/app/components/icon/Icon";
import { FORM_TYPES } from "src/app/modules/auth/constants";
import { AuthContext } from "src/contexts/AuthContext";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { AuthenticateResponse } from "src/core/models/auth";
import { AccountsService } from "src/core/services/auth";

import authCSS from "../Auth.module.css";

const LoginForm = ({ changeForm = (formToDisplay = FORM_TYPES.LOGIN) => {}, onAuthorization = (sucess: boolean) => {} }) => {
  const [passwordType, setPasswordVisibility] = useState(false);
  const [currentState, setFormData] = useState({
    email: "",
    password: "",
  });
  const authData = useContext(AuthContext);
  const modalData = useContext(ModalContext);

  const changePasswordType = () => {
    setPasswordVisibility(!passwordType);
  };
  const isPasswordVisible = passwordType === false;

  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const inputName = event.target.name;
    const inputValue = event.target.value;

    setFormData((currentState) => {
      return {
        ...currentState,
        [inputName]: inputValue,
      };
    });
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    AccountsService.authenticate(currentState)
      .then((response: AuthenticateResponse) => {
        if (response?.jwtToken) {
          authData?.setAuthData(response, true);
        }
        onAuthorization(true);
      })
      .catch((e: ApiResult) => {
        onAuthorization(false);
        modalData?.triggerError(e);
      });
  };

  return (
    <div className="u-flex u-flex-column u-flex-items-center">
      <h3 className="u-t-primary-dark u-t-uppercase u-m0 u-pt10px u-pb40px">prijava</h3>
      <form onSubmit={handleSubmit} className={classNames("u-col-xs-12", "u-col-sm-7", "u-col-md-9", "u-col-lg-7", authCSS.loginForm)}>
        <div className="u-flex u-flex-column">
          <label htmlFor="email" className="u-t-f14p u-ml10px">
            Email
          </label>
          <input type="email" name="email" onChange={onInputChange} className="u-t-f15p u-mb30px" required></input>
          <label htmlFor="password" className="u-t-f14p u-ml10px">
            Lozinka
          </label>
          <div className="u-col-xs-12">
            <input
              type={passwordType ? "text" : "password"}
              name="password"
              onChange={onInputChange}
              className="u-col-xs-12 u-t-f15p u-mb50px u-border-box"
              required
            ></input>
            <button type="button" className={classNames("u-cursor-pointer", "u-pos-absolute", authCSS.eyeIcon)} onClick={changePasswordType}>
              <Icon name={isPasswordVisible ? "eye-blocked" : "eye"} className="u-t-valign-mid u-t-primary" />
            </button>
          </div>
        </div>
        <div className="u-flex u-flex-content-center u-mb30px">
          <button
            type="submit"
            className={classNames(
              "u-bg-primary",
              "u-t-white",
              "u-cursor-pointer",
              "u-t-uppercase",
              "u-col-xs-12",
              "u-col-lg-10",
              "u-col-md-9",
              "u-font-family-inh",
              "u-t-f16p",
              "u-t-lh24",
              authCSS.button
            )}
          >
            Prijavite se
          </button>
        </div>
      </form>
      <hr className="u-col-xs-12 u-col-sm-7 u-col-md-9 u-col-lg-7 u-bt0 u-bl0 u-br0 u-mb20px u-line-base" />

      <div className="u-t-f14p u-mb10px">
        <div>
          Nemate račun?
          <button className={classNames("u-t-underline", "u-cursor-pointer", "u-t-primary")} onClick={() => changeForm(FORM_TYPES.REGISTER)}>
            Registriraj se
          </button>
        </div>
      </div>
      <div className="u-t-halign-c u-mb30px u-t-f14p">
        <button className={classNames("u-t-underline", "u-cursor-pointer", "u-t-primary")} onClick={() => changeForm(FORM_TYPES.FORGOTTEN_PASSWORD)}>
          Zaboravljena lozinka?
        </button>
      </div>
    </div>
  );
};

export default LoginForm;
